import { useSingleton } from "../../other/injection";
import { RouteStore } from "../../other/navigationAndRouting/RouteStore";
import { BigRouteList } from "../../uiLibrary/bigRouteList/BigRouteList";
import { BannerPage } from "../../uiLibrary/bannerPage/BannerPage";
import { settingsRoute } from "../../other/navigationAndRouting/routes";
import { observer } from "mobx-react-lite";

export const SettingsPage = observer(() => {
    const routeStore = useSingleton(RouteStore);
    const routes = routeStore.getChildrenMenuRoutes(settingsRoute);

    return (
        <BannerPage title="Settings">
            <BigRouteList routes={routes} testId="settingLinks" />
        </BannerPage>
    );
});
